export default "__VITE_ASSET__CZO8Q7sH__"